import { Link } from "react-router-dom";
import SEO from "@/components/SEO";
import ParticleField from "@/components/ParticleField";

export default function NotFound() {
  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden">
      <SEO title="404 — Page Not Found | ImJove Tech" description="This page does not exist." />
      <ParticleField className="absolute inset-0 z-0" density={40} />
      <div className="radial-fade absolute inset-0" />
      <div className="relative z-10 px-6 text-center">
        <p className="font-display text-8xl font-bold tracking-tighter text-gold-gradient sm:text-9xl">404</p>
        <p className="mt-4 font-display text-2xl text-white">This part of the universe doesn't exist yet.</p>
        <p className="mt-2 font-body text-white/50">But we're always building what's next.</p>
        <Link to="/" className="btn-gold mt-8 inline-flex items-center rounded-full px-8 py-4 font-mono2 text-[12px] font-semibold uppercase tracking-widest">
          Return Home
        </Link>
      </div>
    </div>
  );
}
